import React, { useEffect } from 'react';
import { IntlPropType } from './propTypes';

import { HeaderProvider, useHeaderContext } from './HeaderContext';
import { IntlContextProvider } from './IntlContext';
import { B2BHeader, Header, Sticky } from './modules';

import { initialState as defaultState } from './store';

export const HeaderModule = () => {
  const { isB2B, loadInitialState } = useHeaderContext();

  useEffect(() => {
    loadInitialState();
  }, []);

  return isB2B ? <B2BHeader /> : <Header />;
};

const HeaderContainer = ({ state: initialState, translations }) => (
  <IntlContextProvider translations={translations}>
    <HeaderProvider initialState={initialState}>
      <Sticky>
        <HeaderModule />
      </Sticky>
    </HeaderProvider>
  </IntlContextProvider>
);

HeaderContainer.propTypes = {
  translations: IntlPropType.isRequired,
  state: HeaderProvider.propTypes.initialState,
};

HeaderContainer.defaultProps = {
  state: defaultState,
};

export default HeaderContainer;
